import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { db } from '../firebase.js';
import { useAuth } from '../contexts/AuthContext.js';
import { useGameSave } from '../hooks/useGameSave.js';
import PlayerDropdown from './PlayerDropdown.js';

function isPlayerValid(p) {
  if (!p) return false;
  if (p.id) return true;
  return Boolean(p.name && p.username);
}

export default function GameForm() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { saveGame } = useGameSave();

  const [players, setPlayers] = useState([]);
  const [player1, setPlayer1] = useState(null);
  const [player2, setPlayer2] = useState(null);
  const [player1Score, setPlayer1Score] = useState('');
  const [player2Score, setPlayer2Score] = useState('');
  const [datePlayed, setDatePlayed] = useState(() => new Date().toISOString().slice(0, 10));
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getDocs(collection(db, 'players')).then(snap => {
      setPlayers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (!isPlayerValid(player1) || !isPlayerValid(player2)) {
      setError('Select or create both players.');
      return;
    }
    if (player1Score === '' || player2Score === '') {
      setError('Enter both scores.');
      return;
    }
    if (player1.id && player2.id && player1.id === player2.id) {
      setError('Players must be different.');
      return;
    }

    setSaving(true);
    try {
      const { gameId } = await saveGame({
        player1,
        player2,
        player1Score: Math.round(Number(player1Score)),
        player2Score: Math.round(Number(player2Score)),
        datePlayed,
        savedByUserId: currentUser?.uid ?? null,
      });
      navigate(`/games/${gameId}`);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <div className="center-page">
      <div className="panel" style={{ maxWidth: 500 }}>
        <Form onSubmit={handleSubmit}>
          <h2>Add a game</h2>
          {error && <Alert variant="danger">{error}</Alert>}

          <PlayerDropdown players={players} label="Player 1" value={player1} onChange={setPlayer1} />
          <PlayerDropdown players={players} label="Player 2" value={player2} onChange={setPlayer2} />

          <Row className="mb-3">
            <Col>
              <Form.Label>Player 1 score</Form.Label>
              <Form.Control type="number" step="1" value={player1Score} onChange={e => setPlayer1Score(e.target.value)} />
            </Col>
            <Col>
              <Form.Label>Player 2 score</Form.Label>
              <Form.Control type="number" step="1" value={player2Score} onChange={e => setPlayer2Score(e.target.value)} />
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Date played</Form.Label>
            <Form.Control type="date" value={datePlayed} onChange={e => setDatePlayed(e.target.value)} />
          </Form.Group>

          <Button type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save game'}</Button>
        </Form>
      </div>
    </div>
  );
}
